// extracted by mini-css-extract-plugin
export default {"disabledSpacesButton":"SpacesSelect-module__disabledSpacesButton--yz3ao"};